/**
 * Helpers for detail tabs that show a historical version of a record.
 * Historical tabs are keyed `recordId@version`; current-record tabs use the ID alone.
 */

export type HistoryTabReference = {
  id?: string;
  version?: number;
};

export function buildHistoryTabId(id: string, version: number): string {
  return `${id}@${version}`;
}

/** IDs without a valid `@version` suffix are returned as current-record IDs. */
export function parseHistoryTabId(
  tabId: string | undefined
): HistoryTabReference {
  if (!tabId) {
    return {};
  }

  const separatorIndex = tabId.lastIndexOf('@');
  if (separatorIndex < 1) {
    return { id: tabId };
  }

  const versionText = tabId.slice(separatorIndex + 1);
  const version = Number(versionText);
  if (!versionText || !Number.isInteger(version) || version < 0) {
    return { id: tabId };
  }

  return { id: tabId.slice(0, separatorIndex), version };
}

/** Tab-label suffix for historical records, e.g. ` - V3`. */
export function historyVersionSuffix(version: number | undefined): string {
  return version === undefined ? '' : ` - V${version}`;
}
